import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(private http: HttpClient) {}

  getAllMedicineInventoryWithCount(data: any): Observable<any> {
    return this.http.post(environment.getAllMedicineInventoryWithCount, data);
  }
  addMedicine(data: any): Observable<any> {
    return this.http.post(environment.addMedicine, data);
  }
  updateMedicine(data: any): Observable<any> {
    return this.http.post(environment.updateMedicine, data);
  }
  deleteMedicine(data: any): Observable<any> {
    return this.http.post(environment.deleteMedicine, data);
  }

  
  
}
